export const PageText = {
  _1: 'Team',
  _2: 'aircheckr is built by an enthusiastic, multidisciplinary team with experiences varying from location based services, full stack web development, environmental engineering and of course data science.'
};

export const avatarItemList = [
  {
    key: 0,
    avatarAlt: 'Olivia Bleeckx',
    text: '<strong>Olivia Bleeckx</strong> is data scientist at aircheckr. She is specialized in data analysis and modelling using tools such as R, Matlab, QGIS or SQL. Currently, she uses her enthusiasm and extensive knowledge in statistical analysis and programming on aircheckr. Olivia is a MSc in Bio-Engineering specialized in environmental data analysis. Previously, she worked at the Belgian Royal Meteorological Institute. Olivia for sure also knows to enthuse you for acroyoga, cohousing and sustainability.'
  },
  {
    key: 1,
    avatarAlt: 'Irakli Dautashvili',
    text: "<strong>Irakli Dautashvili</strong> is a full stack web developer at aircheckr. He is an enthusiastic and curiosity-driven developer, with experience in several modern programming languages and tools (node.js, javascript, ...), both in front and back-end. Irakli has a Bachelor's degree in Computer Science and Information Systems. He is interested in mathematics, physics and video games. Besides his professional occupation, Irakli is a self-taught musician. With major interest in guitar, he is proficient in several other instruments. Also he thinks he is very proficient in Karaoke (… he isn't)."
  },
  {
    key: 2,
    avatarAlt: 'Ashish Vaidya',
    text: '<strong>Ashish Vaidya</strong> is a full stack web developer at nazka mapps. He has a master’s degree in "artificial intelligence and big data" and in "information and communication technology". After 5 years as a web developer in other companies, he now helps nazka with his in-depth expertise in several programming languages and tools (javascript, java, python, ...). He is very enthusiastic about science, technology, music and photography. In his free time, he likes to read books, play guitar and make char coal portraits.'
  },
  {
    key: 3,
    avatarAlt: 'Danut Codrescu',
    text: '<strong>Danut Codrescu</strong> is full stack web developer at nazka mapps. He has a thorough knowledge of different programming languages and frameworks like PHP, Ruby on Rails, Angular, Meteor and Node. He is also experienced in different types of databases: Mongo, MySQL, PostgreSQL and Oracle. Danut is a MSc in Management Science and gained experience in web development at QED. In his spare time, Danut is an enthusiastic long-distance runner and former karate champion. Watch out!'
  },
  {
    key: 4,
    avatarAlt: 'Han Tambuyzer',
    text: '<strong>Han Tambuyzer</strong> is co-founder of nazka and aircheckr. He likes to put the technological outlines and is strong in client tailored development and implementation of (geo-)applications and workflows . His master in bio-engineering and the years of expertise as a teamleader in spatial and environment-related projects add hereto. He has an eye for design and the finishing touch. Han is a DIY-man with a natural preference for geeky stuff but he amuses himself still the best with the most important side issue of the world: football.'
  },
  {
    key: 5,
    avatarAlt: 'Ides Bauwens',
    text: '<strong>Ides Bauwens</strong> is co-founder of nazka and aircheckr. He kicks off new applications with lots of energy and quickly thinks up new ideas and possible solutions. By combining technical with social skills, he forms a strong link between customer and developers. Ides graduated as bio-engineer, and specialized in GIS, Remote Sensing and web development. In his spare time, Ides has telescopic legs, a racing bike covered with dust, and a knight costume to master four kids.'
  },
  {
    key: 6,
    avatarAlt: 'Nicolas Dosselaere',
    text: '<strong>Nicolas Dosselaere</strong> is one of the 3 co-founders of nazka and aircheckr. He is a socially committed geo expert, who is actively involved in the complete innovation & development process. This way he is also a driving force behind aircheckr. Nicolas is a Bio-Engineer and MSc “Geo-Information”. Previously, he was head of the department “Remote Sensing Applications” (Eurosense). Nicolas is a modest but passionate sportsman and a less modest imitator of the singing of the Common Rosefinch.'
  }
];

export const Categories = {
  _1: {
    title: 'Many more',
    subcategories: [
      {
        key: 0,
        text: 'And also many thanks to all external organisations and persons (subcontractors, freelancers, internships & advisors) that supported us in a wide range of issues!'
      }
    ]
  }
};

export default PageText;



// WEBPACK FOOTER //
// ./src/input-text/en/team_page.js